import React, { FunctionComponent } from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  getFontSize,
  getFontWeight,
  getKeyLevel,
  getPadding,
} from '../../utils/utils';
import { ContentDto } from '../../dto/ContentDto';

interface Props {
  dto: ContentDto;
  onOpenDialog: (e: any) => any;
  onClickEdit: (e: any) => any;
  onClickDelete: (e: any) => any;
  onClickNavigate: (e: any) => any;
}

export const RowSectionDivItem: FunctionComponent<Props> = ({
  dto,
  onOpenDialog,
  onClickEdit,
  onClickDelete,
  onClickNavigate,
}) => {
  const level = getKeyLevel(dto?.keyFormat);
  const fontWeightNew = getFontWeight(level);
  const fontSizeNew = getFontSize(level);

  const padding = getPadding(level);
  return (
    <div>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          bgcolor: '#FFFFFF',
          '&:hover': {
            bgcolor: '#ce93d8',
          },
        }}
      >
        <Stack
          direction="row"
          width="100%"
          paddingLeft="20px"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            width="100%"
            paddingLeft={padding}
            onClick={() => onClickNavigate(dto)}
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: fontWeightNew,
                fontSize: fontSizeNew,
                color: '#000000',
              }}
              component="text"
            >
              {`${dto?.keyFormat} ${dto?.name}`}
            </Typography>
          </Stack>
          <Stack direction="row" padding="5px" spacing={1}>
            <IconButton size="small" onClick={() => onOpenDialog(dto)}>
              <FormatListNumberedIcon
                fontSize="small"
                sx={{
                  color: '#009688',
                }}
              />
            </IconButton>
            <IconButton size="small" onClick={() => onClickEdit(dto)}>
              <EditIcon
                fontSize="small"
                sx={{
                  color: '#ff9800',
                }}
              />
            </IconButton>
            <IconButton size="small" onClick={() => onClickDelete(dto)}>
              <DeleteIcon
                fontSize="small"
                sx={{
                  color: '#f44336',
                }}
              />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};
